import React, { forwardRef } from 'react';
import DatePickerIcon from './datePickerIcon';

const CustomInput = ({ className, value, onClick }, ref) => {
    return (
        <div className={className} onClick={onClick} ref={ref}>
            <DatePickerIcon color={`${className.includes('react-datepicker-ignore-onclickoutside') ? '#2e79da' : '#212121'}`} />
            <div className='value'>{value}</div>
        </div>
    )
}

export default forwardRef(CustomInput);
